import { SxProps, Theme } from '@mui/material';
import { fullBleed, gradients, minHeightDvh } from '../../theme/mixins';

// Matches the login screen: the same hero wash carries across both auth steps.
export const pageWrapperStyles: SxProps<Theme> = {
    ...fullBleed,
    background: gradients.heroWash,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: { xs: 5, md: 8 },
    px: 2,
    ...minHeightDvh('calc(100dvh - 200px)'),
};

export const logoBoxStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 4,
};

export const cardStyles: SxProps<Theme> = {
    maxWidth: 540,
    width: '100%',
    boxShadow: '0 20px 48px rgba(16,24,40,0.10)',
    border: '1px solid rgba(16,24,40,0.06)',
};

export const cardContentStyles: SxProps<Theme> = { p: { xs: 3, sm: 4 } };
export const headerBoxStyles: SxProps<Theme> = { textAlign: 'center', mb: 3 };
export const stepperStyles: SxProps<Theme> = { mb: 4 };
export const passwordStrengthBoxStyles: SxProps<Theme> = { mt: 1, mb: 2 };
export const healthInfoBoxStyles: SxProps<Theme> = { textAlign: 'center', py: 4 };
export const preferencesBoxStyles: SxProps<Theme> = { textAlign: 'center', py: 4 };
export const navButtonBoxStyles: SxProps<Theme> = { display: 'flex', justifyContent: 'center', mt: 4 };
export const createAccoutButtonStyles: SxProps<Theme> = { minWidth: 170 };
export const loginContainerStyles: SxProps<Theme> = { textAlign: 'center', mt: 3 };

// Brand blue, not gold — see the note in loginForm.styles.ts on contrast.
export const getLoginLinkStyles = (theme: Theme): SxProps<Theme> => {
    return { color: theme.palette.primary.main, fontWeight: 600 };
};
